(() => {
  function normalize(s) {
    return (s || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function ensurePorts() {
    if (!Array.isArray(window.CM_PORTS) || window.CM_PORTS.length === 0) {
      console.warn("[CM] window.CM_PORTS fehlt/leer. Prüfe ports.js Einbindung.");
      return false;
    }
    return true;
  }

  function createCombobox(root) {
    const input  = root.querySelector("[data-cm-combobox-input]");
    const hidden = root.querySelector("[data-cm-combobox-hidden]");
    const list   = root.querySelector("[data-cm-combobox-list]");
    if (!input || !hidden || !list) return;

    const labelText = root.getAttribute("data-cm-label") || "Bitte wählen";
    const required  = root.hasAttribute("data-cm-required");

    let activeIndex = -1;
    let currentItems = [];

    function openList() {
      // WICHTIG: Liste öffnen (wie bei deinem Schiff-Feld)
      list.classList.add("open");
      root.classList.add("open"); // optional, falls du root.open im CSS nutzt
      input.setAttribute("aria-expanded", "true");
    }

    function closeList() {
      list.classList.remove("open");
      root.classList.remove("open");
      input.setAttribute("aria-expanded", "false");
      activeIndex = -1;
      updateActive();
    }

    function updateActive() {
      const nodes = list.querySelectorAll(".cm-combobox-item");
      nodes.forEach((n, i) => n.classList.toggle("active", i === activeIndex));
    }

    function render(items) {
      list.innerHTML = "";
      currentItems = items;

      if (!items.length) {
        const empty = document.createElement("div");
        empty.className = "cm-combobox-empty";
        empty.textContent = "Keine Treffer";
        list.appendChild(empty);
        return;
      }

      items.forEach((label, idx) => {
        const div = document.createElement("div");
        div.className = "cm-combobox-item";
        div.setAttribute("role", "option");
        div.textContent = label;

        // mousedown -> verhindert blur/close bevor Auswahl gesetzt wird
        div.addEventListener("mousedown", (e) => {
          e.preventDefault();
          chooseIndex(idx);
        });

        list.appendChild(div);
      });
    }

    function chooseIndex(idx) {
      const label = currentItems[idx];
      if (!label) return;

      input.value = label;
      hidden.value = label;

      // Jetzt wirklich schließen:
      closeList();

      // optional: Fokus raus (macht UX oft „fertig“)
      input.blur();

      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function filterAndShow() {
      const q = normalize(input.value);

      // wenn User tippt -> alte Auswahl invalidieren
      hidden.value = "";

      const items = q
        ? window.CM_PORTS.filter(p => normalize(p).includes(q)).slice(0, 200)
        : window.CM_PORTS.slice(0, 200);

      render(items);
      openList();
    }

    // initial
    input.setAttribute("autocomplete", "off");
    input.setAttribute("aria-label", labelText);
    render(window.CM_PORTS.slice(0, 200));

    input.addEventListener("focus", () => {
      render(window.CM_PORTS.slice(0, 200));
      openList();
    });

    input.addEventListener("input", filterAndShow);

    input.addEventListener("keydown", (e) => {
      const isOpen = list.classList.contains("open");
      if (!isOpen && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
        render(window.CM_PORTS.slice(0, 200));
        openList();
      }

      const max = currentItems.length - 1;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, max);
        updateActive();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        updateActive();
      } else if (e.key === "Enter") {
        if (list.classList.contains("open") && activeIndex >= 0) {
          e.preventDefault();
          chooseIndex(activeIndex);
        }
      } else if (e.key === "Escape") {
        closeList();
      }
    });

    // Click outside -> nur diese Instanz schließen
    document.addEventListener("mousedown", (e) => {
      if (!root.contains(e.target)) closeList();
    });

    // required validation im Add-to-cart Form
    const form = root.closest("form");
    if (form && required) {
      form.addEventListener("submit", (e) => {
        if (!hidden.value) {
          e.preventDefault();
          input.focus();
          input.setCustomValidity(`Bitte wähle "${labelText}" aus der Liste.`);
          input.reportValidity();
          setTimeout(() => input.setCustomValidity(""), 600);
        }
      });
    }
  }

  function init() {
    if (!ensurePorts()) return;

    // WICHTIG: nur die echten Port-Comboboxen initialisieren
    document
      .querySelectorAll('.cm-combobox[data-cm-label]')
      .forEach(createCombobox);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();

